import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-4 max-w-4xl mx-auto text-center bg-[#1D0B0B] pt-[18px] pb-[18px] mt-[0px] mb-[0px]" data-id="element-172">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-173">
        <h2 className="text-4xl md:text-5xl font-black mb-8 leading-tight" data-id="element-174">
          El problema no es aprender detailing
          <br data-id="element-175" />
          <span className="text-gray-500 mt-2 block" data-id="element-176">
            Es intentar empezar sin orden.
          </span>
        </h2>

        <p className="text-xl md:text-2xl text-gray-300 mb-8 font-medium" data-id="element-177">
          Tenés información… pero desordenada. Y eso te deja exactamente donde
          estás:
        </p>

        <div className="inline-block bg-red-500/10 border border-red-500/30 px-8 py-4 rounded-2xl" data-id="element-178">
          <p className="text-3xl md:text-4xl font-black text-red-500" data-id="element-179">
            👉 sin avanzar.
          </p>
        </div>
      </motion.div>
    </section>;
}